import React, { KeyboardEventHandler, PointerEventHandler } from 'react';

import { Box } from '@mui/material';

import { MIN_COLUMN_WIDTH, MIN_ROW_HEIGHT, ResizeAxis } from './useTableSizing';

type Props = {
  axis: ResizeAxis;
  label: string;
  size?: number;
  keyboardAccessible?: boolean;
  onPointerDown: PointerEventHandler<HTMLElement>;
  onKeyDown: KeyboardEventHandler<HTMLElement>;
};

export default function TableResizeHandle({
  axis,
  label,
  size,
  keyboardAccessible = true,
  onPointerDown,
  onKeyDown,
}: Props) {
  const column = axis === 'column';
  return (
    <Box
      role={keyboardAccessible ? 'separator' : undefined}
      tabIndex={keyboardAccessible ? 0 : undefined}
      aria-hidden={!keyboardAccessible || undefined}
      aria-label={keyboardAccessible ? label : undefined}
      aria-orientation={keyboardAccessible ? (column ? 'vertical' : 'horizontal') : undefined}
      aria-valuemin={keyboardAccessible ? (column ? MIN_COLUMN_WIDTH : MIN_ROW_HEIGHT) : undefined}
      aria-valuenow={keyboardAccessible && size !== undefined ? Math.round(size) : undefined}
      onPointerDown={onPointerDown}
      onKeyDown={onKeyDown}
      onClick={(event) => event.stopPropagation()}
      sx={{
        position: 'absolute',
        zIndex: 4,
        touchAction: 'none',
        cursor: column ? 'col-resize' : 'row-resize',
        ...(column ? { top: 0, bottom: 0, right: 0, width: 8 } : { left: 0, right: 0, bottom: 0, height: 6 }),
        '&:hover, &:focus-visible': { bgcolor: 'primary.main', outline: '2px solid', outlineColor: 'primary.light' },
      }}
    />
  );
}
